import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { groupValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import GroupForm from "./GroupForm";

const EditGroup = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(groupValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        ...data?.data,
        name: data?.data?.full_name,
        code: data?.data?.code,
        countries: data?.data?.countries?.map((item: Record<string, string>) => ({
          label: item?.name,
          value: item?.id,
        })),
      };

     
    },
  });
  console.log("errors",errors);
  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <GroupForm
        errors={errors}
        register={register}
        setValue={setValue}
        isEdit={true}
        clearErrors={clearErrors}
        getValues={getValues}
        control={control} 
        watch={watch}
      />
    </FormLayout>
  );
};

export default EditGroup;
